import styled from 'styled-components';
import { scrollY } from '@finect/tabular-utils/scrollY';
export var Background = styled.div.withConfig({
  displayName: "Background",
  componentId: "sc-k98oxt-0"
})(["position:absolute;left:0;right:0;height:100%;background-color:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background;
}, scrollY);